module.exports = __webpack_public_path__ + "static/media/logo512.6d717fa0.png";